import { FC } from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { ModalCloseButton } from '../../../../../../brunswick/components/ModalCloseButton'
import { textWithFilterCount } from '../../../../../../brunswick/components/pages/Collection/sections/CollectionGridSection/utils'
import { ProductReviewsContainer } from '../../../../../../containers/ProductReviewsContainer'
import { useProductReviewFilters } from '../../../../../../lib/hooks/useProductReviewFilters'
import { fieldsByFieldType } from '../../../../../../lib/reviews/constants'
import { FieldType } from '../../../../../../lib/reviews/types'
import { getFilterKey } from '../../../../../../lib/reviews/utils'

import { Bar, ClearAllButton, Headline, SelectedCategoryFiltersList, TopActions } from './styles'

export const TopBar: FC<{ onModalCloseClick: () => void }> = ({ onModalCloseClick }) => {
  const { results } = ProductReviewsContainer.useContainer()
  const { filters, activeFilterCount, updateFilters } = useProductReviewFilters()
  const { collections, magnolia } = useTranslation()

  const hasActiveFilters = activeFilterCount > 0
  const selectedFilterValues = [
    ...(filters.rating ? filters.rating : [])
      .map(rating => {
        const displayed =
          rating === '1'
            ? magnolia.reviewsPage.filters.filter.rating.singular!
            : magnolia.reviewsPage.filters.filter.rating.plural!
        return displayed.replace('{{rating}}', rating)
      })
      .sort((a, b) => a.localeCompare(b)),
    ...Object.values(FieldType)
      .map(type => {
        if (!results?.tag) return []

        const field = fieldsByFieldType[results.tag][type]

        if (!field) return []

        return field.values
          .filter(o => filters[type]?.includes(getFilterKey(o.value)))
          .map(({ name }) => name)
      })
      .flat(),
  ].join(', ')

  return (
    <Bar>
      <TopActions>
        <Headline textType='h2'>
          {textWithFilterCount(collections.filtering.filterModal.headline, activeFilterCount)}
        </Headline>
        {hasActiveFilters && (
          <ClearAllButton onClick={() => updateFilters({})}>
            {collections.filtering.filterModal.clearAllFiltersCta}
          </ClearAllButton>
        )}
      </TopActions>
      {selectedFilterValues && (
        <SelectedCategoryFiltersList>{selectedFilterValues}</SelectedCategoryFiltersList>
      )}
      <ModalCloseButton onClick={onModalCloseClick} />
    </Bar>
  )
}
